<template>
	<vxe-modal v-model="showFlag" :title="theTitle" :destroy-on-close="true" :lock-view="false" :lock-scroll="false"
					remember :esc-closable="false" width="600" height="240" show-footer :mask="false">
		<div>
			<a-textarea :rows="5" placeholder="多个表地址之间使用英文逗号分割,最多300字" :max-length="300" v-model="meterAddrListStr"/>
		</div>
		<template #footer>
			<div class="drawerFooter">
			    <a-button size="small" icon="close" @click="onClose()" style="margin-right: 0.5rem;">取 消</a-button>
			    <a-button size="small"  icon="check" type="primary" @click="onSubmit" :loading="submiting">提 交</a-button>
			</div>
		</template>
	</vxe-modal>
</template>

<script>
	export default {
		data() {
			return {
				showFlag:false,
				meterAddrListStr:'',
				submiting:false,
				deviceAddr:'',
				loading:false,
			}
		},
		methods: {
			showView(item){
				this.deviceAddr = item.deviceAddress;
				this.query4MeterData();
				this.showFlag = true;
			},
			onClose(){
				this.showFlag = false;
				this.deviceAddr	= null;
				this.meterAddrListStr = '';
			},
			onSubmit(){
				if(this.meterAddrListStr.length>0){
					this.submiting = true;
					let param = {
						deviceAddr:this.deviceAddr,
						meterAddrs:this.meterAddrListStr
					};
					let url = this.Api.getLastUrl(this.Api.DY_4G_COLLEC_METER_CONFIG_URL);
					this.Api.fetchPostWithForm(url,param).then((data)=>{
						this.submiting = false;
						let code = data.data.code;
						let result = data.data.result;
						let msg = data.data.message;
						if(code == this.Api.HTTP_OK_CODE){
							this.$message.success('配置成功');
							this.onClose();
						}else{
							this.$message.error(msg);
						}
					}).catch((error)=>{
						console.log(error);
						this.submiting = false;
					});
				}else{
					this.$message.error('请输入表地址');
				}
			},
			query4MeterData(){
				let param = {
					deviceAddr:this.deviceAddr
				};
				let url = this.Api.getLastUrl(this.Api.DY_4G_COLLEC_METER_LIST_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.checkResult(result);
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			checkResult(resultList){
				this.meterAddrListStr = '';
				var temp = [];
				for(var i=0;i<resultList.length;i++){
					let item = resultList[i];
					temp.push(item.meter_addr);
				}
				this.meterAddrListStr = temp.join(",");
			},
		},
		computed: {
			theTitle() {
				return "4G设备配置表信息 - "+this. deviceAddr;
			}
		},
	}
</script>

<style>
</style>
